'use strict';

/**
 * Claim
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.Claim = T.createModule({
	start: function start(resolve) {
		var _this = this;

		this.$ctx = $(this._ctx);

		$(window).on('scroll', function () {
			var scrollTop = $(window).scrollTop();
			_this.$ctx.css('top', 'calc(30vh - (' + scrollTop + 'px / 2))');
		});

		this._events.on('slide', function (slide) {
			if (slide.line1 && slide.line2) {
				var titles = $('.a-title', _this.$ctx);
				var line1 = $(titles.get(0));
				var line2 = $(titles.get(1));
				line1.html(slide.line1);
				line2.html(slide.line2);
			}
		});

		resolve();
	}
});